// BADGE IMAGE

// BADGE

// OTHER

// TYPE CHECKS

export function isBadgeImageSelected(item) {
  return item.imageId !== null;
}
export function checkIsBadge(item) {
  return (item === null || item === void 0 ? void 0 : item.isDeleted) === false;
}